import {
  CustomAlertAction,
  CustomAlertState,
} from '../../../alert/controller/custom.alert.controller';
import { CustomAlertIcons } from '../../../alert/data/custom.alert.icon';
import { CustomAlertType } from '../../../alert/data/custom.alert.type';
import { ClientControllerAction, ClientControllerState } from './../controller/client-controller';
import { ClientInfoModel } from '../../client/model/clitent-model';
import { ClientMenuOptionModel } from '../model/clitent-model';
import { ClientChildrenModel, ClientModalChildrenData } from './client-modal-child';
import { ClientModalNames } from './client-modal-name';

export const ClientOptionData = ({
  ctrl,
  alert,
}: {
  ctrl: ClientControllerAction & ClientControllerState;
  alert: CustomAlertState & CustomAlertAction;
}) => {
  const data: ClientMenuOptionModel[] = [
    {
      title: 'ເບິ່ງລາຍລະອຽດ',
      icon: 'eye',
      onPressed: (user: ClientInfoModel) => {
        ctrl.setSelectedItem(user);
        if (user.created_by) ctrl.getStaff(user.created_by);
        ctrl?.onHandleModal(
          ClientModalChildrenData.filter((e: ClientChildrenModel) =>
            e.name.includes(ClientModalNames.INFO)
          )[0]
        );
      },
    },
    {
      title: 'ແກ້ໄຂ',
      icon: 'pen',
      onPressed: (user: ClientInfoModel) => {
        ctrl.onUpdateFormUpdate({
          id: user.uuid,
          first_name: user.first_name,
          last_name: user.last_name,
          position_id: user?.position_id ?? '',
          province_id: user?.province_id ?? '',
          ministry_id: user?.ministry_id ?? '',
          department_id: user?.department_id ?? '',
          email: user.email,
          phone: user.phone,
          status: user.status,
          show_accept_button: user.show_accept_button,
          description: user.description,
          role_id: String(user.role_id),
        });
        ctrl?.onHandleModal(
          ClientModalChildrenData.filter((e: ClientChildrenModel) =>
            e.name.includes(ClientModalNames.UPDATE)
          )[0]
        );
      },
    },
    {
      title: 'ລົບຂໍ້ມູນ',
      icon: 'delete',
      onPressed: (user: ClientInfoModel) => {
        alert.handleCustomAlert({
          title: 'ລົບຂໍ້ມູນ',
          message: 'ທ່ານຕ້ອງການລົບຂໍ້ມູນແທ້ບໍ ?',
          type: CustomAlertType.WARNING,
          icon: CustomAlertIcons.deleteConfirm,
          negText: 'ກັບຄືນ',
          posText: 'ຢືນຢັນ',
          onPositive: () => {
            ctrl.onDelete(user.uuid);
            alert.handleCustomAlert(null);
          },
        });
      },
    },
  ];
  return data;
};
